import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createSlots as _createSlots, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "myCustomStyles relative" };
const _hoisted_2 = { class: "text-black font-medium force-font" };
const _hoisted_3 = {
    id: "dropdowns",
    style: { "display": "flex", "width": "100%", "height": "100vh", "background-color": "#ffffff" }
};
const _hoisted_4 = {
    id: "left-section",
    style: { "width": "25vw", "margin-top": "109px" }
};
const _hoisted_5 = {
    id: "internal-left-section",
    class: "pt-3 py-2 ml-10",
    style: { "width": "75%" }
};
const _hoisted_6 = { class: "flex items-center" };
const _hoisted_7 = { class: "pt-3 checkbox-group flex flex-col" };
const _hoisted_8 = {
    key: 0,
    class: "pt-2"
};
const _hoisted_9 = { class: "text-sm text-gray-500 mb-1 pt-3" };
const _hoisted_10 = { class: "inline-flex items-center" };
const _hoisted_11 = { class: "mr-2 text-sm text-gray-700" };
const _hoisted_12 = { class: "ml-2 text-sm text-gray-700" };
const _hoisted_13 = {
    id: "right-section",
    style: { "width": "75vw", "margin-top": "59px" },
    class: "bg-gray-50"
};
const _hoisted_14 = {
    style: { "margin-top": "40px" },
    class: "ml-8"
};
const _hoisted_15 = { class: "flex justify-center items-center mt-6" };
const _hoisted_16 = { class: "flex flex-col md:!flex-row md:shadow-lg w-full max-w-6xl bg-white lg:py-4" };
const _hoisted_17 = {
    id: "product-details-preview",
    style: { "flex": "0.5" },
    class: "py-4 px-6 md:pl-8 lg:border-r flex flex-col gap-2"
};
const _hoisted_18 = { class: "border-b-2 pb-4 capitalize text-lg" };
const _hoisted_19 = ["src", "alt"];
const _hoisted_20 = { class: "flex justify-between items-center" };
const _hoisted_21 = { class: "flex items-center" };
const _hoisted_22 = {
    key: 0,
    id: "product-img",
    class: "p-2 mr-2"
};
const _hoisted_23 = ["src", "alt"];
const _hoisted_24 = { id: "product-name" };
const _hoisted_25 = { class: "text-right" };
const _hoisted_26 = {
    key: 0,
    class: "font-bold"
};
const _hoisted_27 = { id: "product-price" };
const _hoisted_28 = {
    key: 0,
    id: "recurring-interval"
};
const _hoisted_29 = { key: 0 };
const _hoisted_30 = {
    key: 1,
    id: "trial-period-details",
    class: "font-bold"
};
const _hoisted_31 = {
    key: 2,
    class: "text-gray-500 text-sm"
};
const _hoisted_32 = {
    key: 0,
    id: "setup-fee",
    class: "my-2 flex justify-between"
};
const _hoisted_33 = { class: "font-bold" };
const _hoisted_34 = {
    key: 1,
    class: "flex border-t-2 pb-2 pt-3"
};
const _hoisted_35 = { class: "border-t-2 pb-2 pt-3" };
const _hoisted_36 = {
    key: 0,
    class: "flex justify-between items-center",
    id: "discount"
};
const _hoisted_37 = { class: "text-gray-500" };
const _hoisted_38 = { class: "mx-1 capitalize" };
const _hoisted_39 = { class: "text-right font-bold" };
const _hoisted_40 = { class: "text-right font-bold" };
const _hoisted_41 = {
    key: 1,
    class: "flex justify-between mt-2",
    id: "subtotal"
};
const _hoisted_42 = ["innerHTML"];
const _hoisted_43 = { class: "text-right font-bold" };
const _hoisted_44 = { class: "border-t-2 pb-2 pt-3" };
const _hoisted_45 = {
    id: "total-due-today",
    class: "flex justify-between"
};
const _hoisted_46 = {
    key: 0,
    class: "flex justify-between mt-3",
    id: "total-after-trial"
};
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("span", null, "Total after trial", -1);
const _hoisted_48 = { class: "text-right font-bold" };
const _hoisted_49 = {
    key: 2,
    class: "text-gray-500 text-xs md:block mt-auto"
};
const _hoisted_50 = { class: "flex-[0.5] right-section p-6 md:pr-8 !overflow-y-auto max-h-[70vh]" };
const _hoisted_51 = { id: "payment-link-form" };
const _hoisted_52 = {
    style: { "display": "flex" },
    cl: ""
};
const _hoisted_53 = { style: { "flex": "0.5", "padding-right": "5px" } };
const _hoisted_54 = { style: { "flex": "0.5" } };
const _hoisted_55 = { class: "flex items-center justify-center" };
const _hoisted_56 = {
    key: 1,
    class: "address-info-group"
};
const _hoisted_57 = {
    style: { "display": "flex" },
    cl: ""
};
const _hoisted_58 = { style: { "flex": "0.5", "padding-right": "5px" } };
const _hoisted_59 = { style: { "flex": "0.5" } };
import { useProductSearch } from '@/composition/useProductSearch';
import config from '@/config';
import { PaymentLinksCreationSource, payButtonOptions } from '@/helper';
import { InvoiceService, UrlType } from '@/services/InvoiceService';
import PaymentLinkService from '@/services/PaymentLinksService';
import { ProductService } from '@/services/ProductService';
import { useMainStore } from '@/store/main';
import { SourceType } from '@/types';
import { ChevronLeftIcon, InfoCircleIcon, Save01Icon, Ticket02Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIPaymentElement } from '@gohighlevel/ghl-payment-element';
import { UIButton, UICheckbox, UIForm, UIFormItem, UIInput, UIInputPhone, UISelect, UISwitch, UITextLgMedium, UITextSmNormal, UITextXsRegular, UIToolbar, UIToolbarGroup, UITooltip, useNotification, } from '@gohighlevel/ghl-ui';
import { computed, inject, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import MoonLoader from '../common/table/MoonLoader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PaymentLinksEditor',
    setup(__props) {
        const { t } = useI18n();
        const notification = useNotification();
        const store = useMainStore();
        const router = inject('router');
        const route = inject('route');
        const rootStore = inject('store');
        const isPaymentElementReady = ref(false);
        // TODO - Move everything to formvalue in the next iteration
        const liveMode = ref(true);
        const showCustomerAddresses = ref(false);
        const allowPromotionCodes = ref(false);
        const showPhoneNumber = ref(false);
        const isBrandingPresent = ref(true);
        const formValue = ref({});
        const selectedProduct = ref({});
        const selectedPrice = ref({});
        const paymentLinkName = ref('New Link');
        const selectedPayButton = ref(payButtonOptions[0]);
        const paymentElementEnv = ref(config.ENVIRONMENT);
        const successStatusCodes = [200, 201];
        const summaryData = ref(undefined);
        const couponCode = ref('');
        const couponCodeApplying = ref(false);
        const enableProductSearch = ref(false);
        const productSearch = useProductSearch({ enabled: enableProductSearch });
        const sourceType = ref(PaymentLinksCreationSource.PAYMENTS_DASHBOARD);
        const sourceId = ref('');
        function goBack() {
            router.push({ name: 'payment-links', params: { locationId: store.altId } });
        }
        const stripeOptions = ref({
            mode: 'payment',
            amount: 1000,
            currency: 'usd',
        });
        function updateCustomTextPresent(value) {
            isBrandingPresent.value = value;
            if (!formValue.value?.branding) {
                formValue.value.branding =
                    `Powered by ${rootStore.state.locations?.currentLocation?.name}`.substring(0, 40);
            }
        }
        const selectedPriceSymbol = ref('');
        function onClickPrice(id, price) {
            selectedPrice.value = price;
            selectedPriceSymbol.value =
                store.currencyDetails?.currency[price?.currency]?.symbol || '';
            removeCouponCode();
        }
        function onClickProduct(id, product) {
            selectedProduct.value = product;
            if (selectedProduct.value.prices.length == 1) {
                onClickPrice(undefined, selectedProduct.value.prices[0]);
            }
            else {
                onClickPrice(undefined, {});
            }
        }
        async function setFinalPriceForProduct() {
            if (!selectedPrice.value || !Object.keys(selectedPrice.value).length) {
                return;
            }
            try {
                //summaryData.value = { finalPriceAmount: selectedPrice.value.amount }
                const params = {
                    altId: store.altId,
                    altType: store.altType,
                    source: {
                        type: SourceType.PAYMENT_LINK,
                        id: route.params.id,
                    },
                    products: [
                        {
                            id: selectedPrice.value._id,
                            qty: 1,
                        },
                    ],
                };
                if (couponCode.value)
                    params.couponCode = couponCode.value;
                const { data } = await ProductService.ammountSummary(params);
                summaryData.value = data;
                // Determine final price inclusive of taxes
                summaryData.value.finalPriceAmount = selectedPrice.value?.recurring
                    ? data?.recurringSummary?.total
                    : data.summary.total;
            }
            catch (error) {
                console.error('Error in getting account summary : ', error);
            }
        }
        const taxTooltip = computed(() => {
            if (summaryData.value === undefined ||
                selectedPrice.value.trialPeriod === undefined)
                return '';
            const taxes = summaryData.value.summary.summary;
            if (selectedPrice.value.trialPeriod) {
                Object.keys(summaryData.value.recurringSummary.summary).forEach(tax => {
                    if (taxes[tax])
                        taxes[tax] += summaryData.value.recurringSummary.summary[tax];
                    else
                        taxes[tax] = summaryData.value.recurringSummary.summary[tax];
                });
            }
            return Object.keys(taxes).reduce((acc, tax, idx) => {
                const newLine = idx > 0 ? '</br>' : '';
                acc += `${newLine}${tax}: ${selectedPriceSymbol.value}${taxes[tax]}`;
                return acc;
            }, '');
        });
        const productImage = computed(() => {
            if (!selectedProduct.value.name || !selectedProduct.value.medias?.length)
                return '';
            const images = selectedProduct.value.medias;
            const featuredProduct = images.find(img => img.isFeatured);
            return featuredProduct ? featuredProduct.url : images[0].url;
        });
        function updatePaymentLinkName(value) {
            paymentLinkName.value = value;
        }
        function updateLiveMode(value) {
            liveMode.value = value;
            isPaymentElementReady.value = false;
        }
        function onPaymentCallback(event) {
            if (event.type === 'ready') {
                isPaymentElementReady.value = true;
            }
            else if (event.type === 'error') {
                isPaymentElementReady.value = true;
            }
        }
        function captureCustomerAddresses(checked) {
            showCustomerAddresses.value = checked;
        }
        function capturePhoneNumber(checked) {
            showPhoneNumber.value = checked;
        }
        function updatePayButton(value, selectedPayObject) {
            if (selectedPayObject === null)
                return;
            selectedPayButton.value = selectedPayObject;
        }
        const products = computed(() => {
            const selectedProductId = selectedProduct.value._id;
            const selectedOption = selectedProductId ? [selectedProduct.value] : [];
            return selectedOption.concat(productSearch.productsData.value.flatMap((product) => {
                if (selectedProductId && product._id === selectedProductId)
                    return [];
                return [prepareProductOptions(product)];
            }));
        });
        const prepareProductOptions = product => {
            return {
                ...product,
                label: product.name,
                value: product._id,
                disabled: false,
                prices: product.prices.map((price) => {
                    return {
                        label: price.name,
                        value: price._id,
                        disabled: false,
                        ...price,
                    };
                }),
            };
        };
        const productDisplayName = computed(() => {
            if (!selectedProduct.value.prices?.length)
                return '';
            return selectedProduct.value.prices.length === 1
                ? selectedProduct.value.name
                : `${selectedProduct.value.name} ${selectedPrice.value.name}`;
        });
        function handleScroll(e) {
            const currentTarget = e.currentTarget;
            if (currentTarget.scrollTop + currentTarget.offsetHeight >=
                currentTarget.scrollHeight - 2) {
                productSearch.fetchNextPage();
            }
        }
        async function getPaymentLinkUrl(paymentLinkId) {
            // get payment url from api
            try {
                const { data } = await InvoiceService.generateUrl({
                    id: paymentLinkId,
                    type: UrlType.PAYMENT_LINK,
                    shortUrl: false,
                });
                return data?.url;
            }
            catch (err) {
                console.error(err);
            }
        }
        async function onClickPreview() {
            if (!validatePaymentLinkConfig())
                return;
            notification.success({
                content: `${t('notification.savingLink')}`,
                duration: 3000,
                keepAliveOnHover: false,
            });
            const paymentLinkId = await onClickSave(true);
            const redirectUrl = await getPaymentLinkUrl(paymentLinkId);
            if (route.params.id == 'new') {
                window.open(redirectUrl, '_blank').focus();
                router.push({
                    name: 'payment-links-editor',
                    params: { id: paymentLinkId },
                });
            }
            else {
                window.open(redirectUrl, '_blank').focus();
            }
        }
        const validatePaymentLinkConfig = () => {
            if (!selectedProduct.value ||
                Object.keys(selectedProduct.value).length === 0 ||
                !selectedPrice.value ||
                Object.keys(selectedPrice.value).length === 0) {
                notification.error({
                    content: `${t('validation.productPrice')}`,
                    duration: 3000,
                    keepAliveOnHover: false,
                });
                return false;
            }
            if (isBrandingPresent.value) {
                if (!formValue.value.branding) {
                    notification.error({
                        content: `${t('validation.branding')}`,
                        duration: 3000,
                        keepAliveOnHover: false,
                    });
                    return false;
                }
            }
            if (!paymentLinkName.value) {
                notification.error({
                    content: `${t('validation.linkName')}`,
                    duration: 3000,
                    keepAliveOnHover: false,
                });
                return false;
            }
            return true;
        };
        const onClickSave = async (redirectToPreview) => {
            try {
                if (!validatePaymentLinkConfig())
                    return;
                const productData = { _id: selectedProduct.value._id };
                productData.prices = [{ _id: selectedPrice.value._id }];
                const dataToSave = {
                    altId: route.params.location_id,
                    altType: 'location',
                    captureCustomerAddress: showCustomerAddresses.value,
                    allowPromotionCodes: allowPromotionCodes.value,
                    captureCustomerPhone: showPhoneNumber.value,
                    collectTax: false,
                    paymentButtonText: selectedPayButton.value.value,
                    linkName: paymentLinkName.value,
                    products: [productData],
                    liveMode: liveMode.value,
                    sourceType: sourceType.value,
                };
                const paymentLinkId = route.params.id;
                if (isBrandingPresent.value) {
                    dataToSave.branding = formValue.value.branding;
                }
                else {
                    dataToSave.branding = '';
                }
                if (sourceId.value) {
                    dataToSave.sourceId = sourceId.value;
                }
                let isPaymentLinkSavedSucessfully = false;
                if (paymentLinkId == 'new') {
                    // create a new payment link
                    const { data, status } = await PaymentLinkService.createNewPaymentLink(dataToSave);
                    if (successStatusCodes.includes(status))
                        isPaymentLinkSavedSucessfully = true;
                    if (!redirectToPreview) {
                        router.push({
                            name: 'payment-links-editor',
                            params: { id: data.paymentLink._id },
                        });
                    }
                    else {
                        return data.paymentLink._id;
                    }
                }
                else {
                    // update a payment link
                    dataToSave.active = true;
                    const { data, status } = await PaymentLinkService.updatePaymentLink(paymentLinkId, dataToSave);
                    if (status == 200)
                        isPaymentLinkSavedSucessfully = true;
                    if (redirectToPreview) {
                        return data.paymentLink._id;
                    }
                }
                notification.success({
                    content: isPaymentLinkSavedSucessfully
                        ? `${t('notification.saveSuccessful')}`
                        : `${t('notification.saveUnsuccessful')}`,
                    duration: 5000,
                    keepAliveOnHover: true,
                });
            }
            catch (error) {
                console.error('Error in Saving the Payment Link');
                notification.error({
                    content: `${t('notification.saveError')}`,
                    duration: 3000,
                    keepAliveOnHover: true,
                });
            }
        };
        async function getPaymentLinkDetails(paymentLinkId) {
            let data;
            try {
                const resp = await PaymentLinkService.getPaymentLinkById(paymentLinkId);
                data = resp.data;
            }
            catch (err) {
                const errMsg = err.response?.data?.message || 'Error fetching payment link';
                notification.error({
                    content: errMsg,
                    duration: 3000,
                    keepAliveOnHover: false,
                });
                return;
            }
            showPhoneNumber.value = data.captureCustomerPhone;
            showCustomerAddresses.value = data.captureCustomerAddress;
            allowPromotionCodes.value = data.allowPromotionCodes;
            selectedPayButton.value = {
                label: data.paymentButtonText,
                value: data.paymentButtonText,
            };
            const selectedProductId = data.products[0]._id;
            const { data: selectedProductData } = await ProductService.getProducts({
                productIds: [selectedProductId],
                offset: 0,
                limit: 1,
                locationId: store.altId,
            });
            selectedProduct.value = prepareProductOptions(selectedProductData.products[0]);
            const selectedPrice = selectedProduct.value.prices.find(price => price._id === data.products[0].prices[0]._id);
            onClickPrice(undefined, selectedPrice || {});
            paymentLinkName.value = data.linkName || 'New Link';
            liveMode.value = data.liveMode;
            if (data?.sourceType == PaymentLinksCreationSource.EMAIL_CAMPAIGN) {
                sourceType.value = data?.sourceType;
                sourceId.value = data?.sourceId;
            }
            if (data?.branding) {
                isBrandingPresent.value = true;
                formValue.value.branding = data?.branding;
            }
            else {
                isBrandingPresent.value = false;
            }
        }
        const priceBreakdown = computed(() => {
            if (selectedPrice.value.amount === undefined ||
                summaryData.value === undefined)
                return {
                    subtotal: 0,
                    discount: 0,
                    dueToday: 0,
                    dueAfterTrial: 0,
                };
            let taxes = summaryData.value.summary.tax;
            let subtotal = summaryData.value.summary.subtotalWithDiscount;
            let dueAfterTrial = 0;
            let discount = summaryData.value.summary.discount;
            if (selectedPrice.value.trialPeriod) {
                subtotal += summaryData.value.recurringSummary?.subtotalWithDiscount;
                taxes += summaryData.value.recurringSummary?.tax;
                dueAfterTrial = summaryData.value.recurringSummary?.total;
                discount += summaryData.value.recurringSummary?.discount;
            }
            return {
                subtotal,
                discount,
                dueToday: summaryData.value.summary.total,
                dueAfterTrial,
                taxes,
            };
        });
        const removeCouponCode = () => {
            couponCode.value = '';
            setFinalPriceForProduct();
        };
        const onCouponApply = async () => {
            couponCodeApplying.value = true;
            await setFinalPriceForProduct();
            if (!summaryData.value?.coupon.valid) {
                notification.error({
                    title: summaryData.value.coupon.errorMessage ||
                        t('notification.invalidCoupon'),
                    keepAliveOnHover: true,
                    duration: 5000,
                });
            }
            couponCodeApplying.value = false;
        };
        onMounted(async () => {
            const paymentLinkId = route.params.id;
            if (paymentLinkId !== 'new') {
                await getPaymentLinkDetails(paymentLinkId);
            }
            else {
                formValue.value.branding =
                    `Powered by ${rootStore.state.locations?.currentLocation?.name}`.substring(0, 40);
            }
            enableProductSearch.value = true;
        });
        return (_ctx, _cache) => {
            const _component_UISpin = _resolveComponent("UISpin");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createVNode(_unref(UIToolbar), {
                        theme: 'light',
                        class: "pt-2 fixed w-full mt-0"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UIToolbarGroup), null, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIButton), {
                                        id: "btn-1",
                                        text: "",
                                        onClick: goBack
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(ChevronLeftIcon), { class: "w-8 h-8 text-black" }),
                                            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('common.back')), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(UIToolbarGroup), null, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIInput), {
                                        id: 'payment-link-name',
                                        modelValue: paymentLinkName.value,
                                        "onUpdate:modelValue": [
                                            _cache[0] || (_cache[0] = ($event) => ((paymentLinkName).value = $event)),
                                            updatePaymentLinkName
                                        ],
                                        disabled: sourceType.value == _unref(PaymentLinksCreationSource).EMAIL_CAMPAIGN,
                                        placeholder: `${_unref(t)('editor.linkName')}`,
                                        type: 'text',
                                        size: 'medium',
                                        style: { "max-width": "150px" },
                                        class: "text-center pl-1"
                                    }, null, 8, ["modelValue", "disabled", "placeholder"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(UIToolbarGroup), { class: "flex items-end" }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIButton), {
                                        id: "product-editor-cancel",
                                        onClick: onClickPreview,
                                        disabled: false
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(t)('editor.preview')), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(UIButton), {
                                        id: "product-editor-save",
                                        type: "primary",
                                        onClick: _cache[1] || (_cache[1] = () => onClickSave(false)),
                                        disabled: false,
                                        loading: false
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Save01Icon), { class: "h-4 w-4 mr-1" }),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.save')), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", null, [
                                _createVNode(_unref(UIForm), {
                                    id: "payment-links-editor-form",
                                    ref: "root",
                                    model: formValue.value,
                                    showLabel: false
                                }, null, 8, ["model"]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_unref(UITextSmNormal), null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(t)('editor.Product')), 1)
                                        ]),
                                        _: 1
                                    }),
                                    (sourceType.value == _unref(PaymentLinksCreationSource).EMAIL_CAMPAIGN)
                                        ? (_openBlock(), _createBlock(_unref(UITooltip), {
                                            key: 0,
                                            placement: 'right'
                                        }, {
                                            trigger: _withCtx(() => [
                                                _createVNode(_unref(InfoCircleIcon), { class: "text-gray-900 ml-1 mt-0.5 h-4 w-4" })
                                            ]),
                                            default: _withCtx(() => [
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('editor.productTooltip')), 1)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _createVNode(_unref(UISelect), {
                                    disabled: sourceType.value == _unref(PaymentLinksCreationSource).EMAIL_CAMPAIGN,
                                    class: "mt-1 product-select",
                                    filterable: "",
                                    id: "select-product-id",
                                    remote: "",
                                    size: 'large',
                                    placeholder: _ctx.$t('editor.productPlaceholder'),
                                    value: selectedProduct.value.value,
                                    options: products.value,
                                    loading: Boolean(_unref(productSearch).loading.value),
                                    "reset-menu-on-options-change": false,
                                    "onUpdate:value": onClickProduct,
                                    onSearch: _unref(productSearch).search,
                                    onScroll: handleScroll,
                                    "onUpdate:show": _cache[2] || (_cache[2] = (show) => !show && _unref(productSearch).clearQuery())
                                }, _createSlots({ _: 2 }, [
                                    (_unref(productSearch).loading.value)
                                        ? {
                                            name: "empty",
                                            fn: _withCtx(() => [
                                                _createVNode(_component_UISpin, { size: "small" })
                                            ]),
                                            key: "0"
                                        }
                                        : undefined
                                ]), 1032, ["disabled", "placeholder", "value", "options", "loading", "onSearch"])
                            ]),
                            _createVNode(_unref(UITextSmNormal), { class: "mt-2" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('editor.Price')), 1)
                                ]),
                                _: 1
                            }),
                            (_openBlock(), _createElementBlock("div", {
                                key: selectedProduct.value.value ? selectedProduct.value.value._id : 'default',
                                class: "mt-1"
                            }, [
                                _createVNode(_unref(UISelect), {
                                    disabled: sourceType.value == _unref(PaymentLinksCreationSource).EMAIL_CAMPAIGN,
                                    id: selectedProduct.value.value ?? 'default',
                                    placeholder: _ctx.$t('editor.pricePlaceholder'),
                                    "onUpdate:value": onClickPrice,
                                    value: selectedPrice.value.value ? selectedPrice.value.value : null,
                                    options: selectedProduct.value?.prices || []
                                }, null, 8, ["disabled", "id", "placeholder", "value", "options"])
                            ])),
                            _createVNode(_unref(UITextLgMedium), { class: "pt-3" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('editor.options')), 1)
                                ]),
                                _: 1
                            }),
                            _createElementVNode("div", _hoisted_7, [
                                _createVNode(_unref(UICheckbox), {
                                    id: `option1-checkbox`,
                                    class: "checkbox",
                                    checked: showPhoneNumber.value,
                                    "onUpdate:checked": capturePhoneNumber
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)('editor.requireCustomerPhone')), 1)
                                    ]),
                                    _: 1
                                }, 8, ["checked"]),
                                _createVNode(_unref(UICheckbox), {
                                    id: `option1-checkbox`,
                                    class: "checkbox",
                                    checked: showCustomerAddresses.value,
                                    "onUpdate:checked": captureCustomerAddresses
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)('editor.collectCustomerAddress')), 1)
                                    ]),
                                    _: 1
                                }, 8, ["checked"]),
                                _createVNode(_unref(UICheckbox), {
                                    id: "allow-coupon-code",
                                    class: "checkbox",
                                    checked: allowPromotionCodes.value,
                                    "onUpdate:checked": [
                                        _cache[3] || (_cache[3] = ($event) => ((allowPromotionCodes).value = $event)),
                                        _cache[4] || (_cache[4] = val => !val && removeCouponCode())
                                    ]
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)('editor.allowCouponCodes')), 1)
                                    ]),
                                    _: 1
                                }, 8, ["checked"])
                            ]),
                            _createVNode(_unref(UITextLgMedium), { class: "pt-3 pb-3" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('editor.advanceOptions')), 1)
                                ]),
                                _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('editor.callToAction')), 1),
                            _createVNode(_unref(UISelect), {
                                id: 'select-pay-button',
                                options: _unref(payButtonOptions),
                                size: 'medium',
                                value: selectedPayButton.value.value,
                                "onUpdate:value": updatePayButton,
                                class: _normalizeClass('pt-1 pb-3')
                            }, null, 8, ["options", "value"]),
                            _createVNode(_unref(UICheckbox), {
                                id: `option1-checkbox`,
                                class: "checkbox",
                                checked: isBrandingPresent.value,
                                "onUpdate:checked": updateCustomTextPresent
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('editor.branding')), 1)
                                ]),
                                _: 1
                            }, 8, ["checked"]),
                            (isBrandingPresent.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(_unref(UIFormItem), {
                                        path: "branding",
                                        style: { "--n-feedback-height": "0", "--n-blank-height": "0", "--n-label-height": "0" }
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(UIInput), {
                                                id: 'custom-text',
                                                modelValue: formValue.value.branding,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((formValue.value.branding) = $event)),
                                                placeholder: `${_unref(t)('editor.brandingPlaceholder')}`,
                                                type: 'text',
                                                readonly: false,
                                                rows: 3,
                                                maxlength: 40,
                                                minlength: undefined,
                                                clearable: false,
                                                size: 'large',
                                                showCount: true
                                            }, null, 8, ["modelValue", "placeholder"])
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('common.paymentMode')), 1),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('common.test')), 1),
                                _createVNode(_unref(UISwitch), {
                                    id: "paymentMode",
                                    disabled: false,
                                    value: liveMode.value,
                                    "onUpdate:value": updateLiveMode
                                }, null, 8, ["value"]),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('common.live')), 1)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_unref(UITextLgMedium), null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('editor.preview')), 1)
                                ]),
                                _: 1
                            }),
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                            (_unref(rootStore).state.locations?.currentLocation?.logo_url)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: _unref(rootStore).state.locations?.currentLocation?.logo_url,
                                                    alt: _unref(rootStore).state.locations?.currentLocation?.name,
                                                    class: "w-4 h-4 mr-1 inline-block rounded-full"
                                                }, null, 8, _hoisted_19))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(_unref(rootStore).state.locations?.currentLocation?.name), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_20, [
                                            _createElementVNode("div", _hoisted_21, [
                                                (productImage.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                        _createElementVNode("img", {
                                                            src: productImage.value,
                                                            alt: selectedProduct.value.name,
                                                            class: "h-12 w-12 md:h-14 md:w-14 object-contain"
                                                        }, null, 8, _hoisted_23)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_24, _toDisplayString(productDisplayName.value), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_25, [
                                                (!selectedPrice.value.trialPeriod)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                        _createElementVNode("span", _hoisted_27, _toDisplayString(selectedPriceSymbol.value) + _toDisplayString(selectedPrice.value.amount), 1),
                                                        (selectedPrice.value.recurring?.interval)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                                                _createTextVNode(" / "),
                                                                (selectedPrice.value?.recurring?.intervalCount)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(selectedPrice.value.recurring.intervalCount), 1))
                                                                    : _createCommentVNode("", true),
                                                                _createTextVNode(" " + _toDisplayString(_unref(t)(`common.${selectedPrice.value?.recurring?.interval}`)), 1)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(`${selectedPrice.value.trialPeriod} ${_unref(t)('common.day', selectedPrice.value.trialPeriod)} ${_unref(t)('common.free')}`), 1)),
                                                (selectedPrice.value.trialPeriod)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(t)('editor.priceAfterTrial', {
                                                        price: selectedPrice.value.amount,
                                                        currency: selectedPriceSymbol.value,
                                                        interval: selectedPrice.value.recurring?.interval,
                                                        intervalCount: selectedPrice.value.recurring?.intervalCount,
                                                    }, { plural: selectedPrice.value.recurring?.intervalCount })), 1))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]),
                                        (selectedPrice.value.setupFee)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", null, _toDisplayString(_unref(t)('editor.additionalSetupFee')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_33, _toDisplayString(selectedPriceSymbol.value) + _toDisplayString(selectedPrice.value.setupFee), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (allowPromotionCodes.value && !summaryData.value?.coupon?.valid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                _createVNode(_unref(UIFormItem), {
                                                    path: "couponCode",
                                                    style: { "--n-feedback-height": "0", "--n-blank-height": "0", "--n-label-height": "0" },
                                                    class: "flex-grow"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(UIInput), {
                                                            placeholder: "Enter coupon code",
                                                            id: "coupon-code",
                                                            value: couponCode.value,
                                                            "onUpdate:value": _cache[6] || (_cache[6] = ($event) => ((couponCode).value = $event))
                                                        }, null, 8, ["value"])
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_unref(UIButton), {
                                                    id: "coupon-code-btn",
                                                    type: "primary",
                                                    class: "ml-2",
                                                    disabled: !couponCode.value || !selectedProduct.value._id || !selectedPrice.value._id,
                                                    loading: couponCodeApplying.value,
                                                    onClick: onCouponApply
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(t)('common.apply')), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["disabled", "loading"])
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_35, [
                                            (summaryData.value?.coupon?.valid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("div", null, _toDisplayString(_unref(t)('editor.discount')), 1),
                                                        _createElementVNode("div", _hoisted_37, [
                                                            _createVNode(_unref(Ticket02Icon), { class: "w-3 h-3 inline-block mb-0.5" }),
                                                            _createElementVNode("span", _hoisted_38, _toDisplayString(couponCode.value), 1),
                                                            _createElementVNode("span", {
                                                                class: "text-red-500 cursor-pointer",
                                                                onClick: removeCouponCode
                                                            }, _toDisplayString(_unref(t)('common.remove')), 1)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_39, " -" + _toDisplayString(selectedPriceSymbol.value) + _toDisplayString(priceBreakdown.value.discount), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["flex justify-between", { 'mt-2': summaryData.value?.coupon?.valid }]),
                                                id: "subtotal"
                                            }, [
                                                _createElementVNode("div", null, _toDisplayString(summaryData.value?.coupon?.valid
                                                    ? _unref(t)('editor.subtotalAfterDiscount')
                                                    : _unref(t)('editor.subtotal')), 1),
                                                _createElementVNode("div", _hoisted_40, _toDisplayString(selectedPriceSymbol.value) + _toDisplayString(priceBreakdown.value.subtotal), 1)
                                            ], 2),
                                            (taxTooltip.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                    _createElementVNode("div", null, [
                                                        _createTextVNode(_toDisplayString(_unref(t)('editor.taxes')) + " ", 1),
                                                        _createVNode(_unref(UITooltip), { placement: "left-start" }, {
                                                            trigger: _withCtx(() => [
                                                                _createVNode(_unref(InfoCircleIcon), { class: "w-4 h-4 inline-block ml-0.5 mb-1" })
                                                            ]),
                                                            default: _withCtx(() => [
                                                                _createElementVNode("div", { innerHTML: taxTooltip.value }, null, 8, _hoisted_42)
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _createElementVNode("div", _hoisted_43, _toDisplayString(selectedPriceSymbol.value) + _toDisplayString(priceBreakdown.value.taxes), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_44, [
                                            _createElementVNode("div", _hoisted_45, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass({
                                                        'text-gray-500': selectedPrice.value.trialPeriod,
                                                    })
                                                }, _toDisplayString(selectedPrice.value.type === 'recurring'
                                                    ? 'Total due today'
                                                    : 'Total'), 3),
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["text-right font-bold text-2xl", {
                                                            'text-gray-500': selectedPrice.value.trialPeriod,
                                                        }])
                                                }, _toDisplayString(selectedPriceSymbol.value) + _toDisplayString(priceBreakdown.value.dueToday), 3)
                                            ]),
                                            (selectedPrice.value.trialPeriod)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                    _hoisted_47,
                                                    _createElementVNode("span", _hoisted_48, _toDisplayString(selectedPriceSymbol.value) + _toDisplayString(priceBreakdown.value.dueAfterTrial), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        (isBrandingPresent.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(formValue.value.branding), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("div", _hoisted_51, [
                                            _createElementVNode("div", _hoisted_52, [
                                                _createElementVNode("div", _hoisted_53, [
                                                    _createVNode(_unref(UIFormItem), {
                                                        label: `${_unref(t)('editor.firstName')}`,
                                                        path: "firstname",
                                                        required: true,
                                                        style: { "--n-feedback-height": "0", "--n-blank-height": "0", "--n-label-height": "0", "padding-top": "8px" }
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(UIInput), {
                                                                placeholder: `${_unref(t)('editor.firstName')}`,
                                                                id: 'user-address-firstname',
                                                                value: formValue.value.firstname,
                                                                "onUpdate:value": _cache[7] || (_cache[7] = ($event) => ((formValue.value.firstname) = $event))
                                                            }, null, 8, ["placeholder", "value"])
                                                        ]),
                                                        _: 1
                                                    }, 8, ["label"])
                                                ]),
                                                _createElementVNode("div", _hoisted_54, [
                                                    _createVNode(_unref(UIFormItem), {
                                                        label: `${_unref(t)('editor.lastName')}`,
                                                        path: "lastname",
                                                        required: true,
                                                        style: { "--n-feedback-height": "0", "--n-blank-height": "0", "--n-label-height": "0", "padding-top": "8px" }
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(UIInput), {
                                                                placeholder: `${_unref(t)('editor.lastName')}`,
                                                                id: 'user-address-lastname',
                                                                value: formValue.value.lastname,
                                                                "onUpdate:value": _cache[8] || (_cache[8] = ($event) => ((formValue.value.lastname) = $event))
                                                            }, null, 8, ["placeholder", "value"])
                                                        ]),
                                                        _: 1
                                                    }, 8, ["label"])
                                                ])
                                            ]),
                                            _createVNode(_unref(UIFormItem), {
                                                label: `${_unref(t)('editor.email')}`,
                                                path: "email",
                                                required: true,
                                                style: { "--n-feedback-height": "0", "--n-blank-height": "0", "--n-label-height": "0", "padding-top": "8px" },
                                                class: "!border-0 !pl-0 !pr-0"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(UIInput), {
                                                        placeholder: 'abc@gmail.com',
                                                        id: 'user-email-address',
                                                        type: 'email',
                                                        value: formValue.value.email,
                                                        "onUpdate:value": _cache[9] || (_cache[9] = ($event) => ((formValue.value.email) = $event))
                                                    }, null, 8, ["placeholder", "value"])
                                                ]),
                                                _: 1
                                            }, 8, ["label"]),
                                            (showPhoneNumber.value)
                                                ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                                    key: 0,
                                                    class: "mt-3",
                                                    label: `${_unref(t)('editor.phone')}`,
                                                    path: "phone",
                                                    required: showPhoneNumber.value,
                                                    style: { "--n-feedback-height": "0" }
                                                }, {
                                                    default: _withCtx(() => [
                                                        (showPhoneNumber.value)
                                                            ? (_openBlock(), _createBlock(_unref(UIInputPhone), {
                                                                key: 0,
                                                                id: "input-phone",
                                                                disabled: false,
                                                                "country-code": 'US'
                                                            }))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                }, 8, ["label", "required"]))
                                                : _createCommentVNode("", true),
                                            (_openBlock(), _createElementBlock("div", {
                                                class: "pb-3 mt-3",
                                                key: `${liveMode.value}`
                                            }, [
                                                _createElementVNode("div", _hoisted_55, [
                                                    (!isPaymentElementReady.value)
                                                        ? (_openBlock(), _createBlock(MoonLoader, {
                                                            key: 0,
                                                            color: "#188bf6",
                                                            size: "30px",
                                                            class: "loader"
                                                        }))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createVNode(_unref(UIPaymentElement), {
                                                    ref: "paymentElementRef",
                                                    env: paymentElementEnv.value,
                                                    id: "payment-element",
                                                    altId: _unref(store).altId,
                                                    altType: "location",
                                                    liveMode: liveMode.value,
                                                    debug: true,
                                                    stripeOptions: stripeOptions.value,
                                                    onPaymentCallback: onPaymentCallback
                                                }, null, 8, ["env", "altId", "liveMode", "stripeOptions"])
                                            ])),
                                            (showCustomerAddresses.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                    _createVNode(_unref(UIFormItem), {
                                                        label: `${_unref(t)('editor.address')}`,
                                                        style: { "--n-feedback-height": "0" }
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(UIInput), {
                                                                placeholder: `${_unref(t)('editor.addressLine1')}`,
                                                                id: 'user-address-line1'
                                                            }, null, 8, ["placeholder"])
                                                        ]),
                                                        _: 1
                                                    }, 8, ["label"]),
                                                    _createVNode(_unref(UIInput), {
                                                        placeholder: `${_unref(t)('editor.addressLine2')}`,
                                                        id: 'user-address-line2'
                                                    }, null, 8, ["placeholder"]),
                                                    _createElementVNode("div", _hoisted_57, [
                                                        _createElementVNode("div", _hoisted_58, [
                                                            _createVNode(_unref(UIInput), {
                                                                placeholder: `${_unref(t)('editor.city')}`,
                                                                id: 'user-address-city'
                                                            }, null, 8, ["placeholder"])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_59, [
                                                            _createVNode(_unref(UIInput), {
                                                                placeholder: `${_unref(t)('editor.state')}`,
                                                                id: 'user-address-state'
                                                            }, null, 8, ["placeholder"])
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createVNode(_unref(UIButton), {
                                                id: 'paybutton',
                                                type: 'primary',
                                                text: false,
                                                class: "w-full mt-2"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(selectedPayButton.value.value), 1)
                                                ]),
                                                _: 1
                                            }),
                                            (selectedPrice.value?.trialPeriod &&
                                                summaryData.value?.finalPriceAmount)
                                                ? (_openBlock(), _createBlock(_unref(UITextXsRegular), {
                                                    key: 2,
                                                    class: "mt-2 text-center text-gray-500"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(`${_unref(t)('editor.afterTrialText')} ${selectedPriceSymbol.value}${summaryData.value.finalPriceAmount}. ${_unref(t)('editor.afterTrialCancellationText')}`), 1)
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (selectedPrice.value.type == 'recurring' &&
                                                !selectedPrice.value.trialPeriod)
                                                ? (_openBlock(), _createBlock(_unref(UITextXsRegular), {
                                                    key: 3,
                                                    class: "mt-2 text-center text-gray-500"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(`${_unref(t)('editor.subscriptionTextPrefix')} ${_unref(rootStore).state.locations?.currentLocation?.name} ${_unref(t)('editor.subscriptionTextSuffix')}`), 1)
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
